import React from 'react';
import {Select} from "antd";
import {IAssetSelectView} from "./type/asset-select-types";


const AssetSelectView: React.FC<IAssetSelectView> = (props) => {

    function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
        //it will call search api when enter is pressed
        if (e.key === 'Enter') {
            //to stop dropdown from closing on pressing enter
            e.preventDefault();
            e.stopPropagation();
            //detect the enter key event
            const value = (e.target as HTMLInputElement).value;
            //call the search api with given string
            props.handleSearch(value);
        }
    }


    function handleScroll(e: React.UIEvent<HTMLDivElement>) {
        const el = e.target as HTMLElement;
        console.log(props.paginationControls.hasPrevious, props.paginationControls.hasNext, '123456789')
        if (props.paginationControls.isLoading) return;

        const isAtTop = el.scrollTop <= 5;
        const isAtBottom =
            el.scrollTop + el.clientHeight >= el.scrollHeight - 5;

        if (isAtTop && props.paginationControls.hasPrevious) {

            props.paginationControls.loadPrevious();
        }

        if (isAtBottom && props.paginationControls.hasNext) {

            props.paginationControls.loadNext();
        }
    }

    return (
        <Select
            disabled={props.disabled ?? false}
            showSearch
            autoClearSearchValue={false}
            filterOption={false}
            onChange={(val: string) => props.handleChange(val)}
            onPopupScroll={handleScroll}
            onInputKeyDown={handleKeyDown}
            onDropdownVisibleChange={props.handleDropdownClose}
            placeholder={props.placeholderText}
        >
            {props.data.map((asset) => (
                <Select.Option key={asset.id} value={asset.id}>
                    <div className="asset-option">
                        <span className="assetCode">{asset.assetCode}, {asset.brandName}</span>
                    </div>
                </Select.Option>
            ))}
        </Select>
    )
}

export default AssetSelectView;